/* Shared scroll-reveal: fade-up on section headings and region cards
   only. Classes are added from JS, so no-JS visitors see everything;
   prefers-reduced-motion disables it entirely. */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var targets = document.querySelectorAll('.btm-dr-header, .btm-dr-card, .btm-dr-footnote');
  if (!targets.length) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-revealed');
      io.unobserve(e.target);
    });
  }, { threshold: 0.15 });

  targets.forEach(function (el) {
    el.classList.add('btm-reveal');
    io.observe(el);
  });
})();
